import { layoutOf } from "../../domain/layout";
import { singleAxle } from "../wheel-placements";
import { CAR, FRONT_AXLE_X, HALF_TRACK, REAR_AXLE_X } from "./dimensions";
const axle = (index, x) => singleAxle({
  axle: index,
  x,
  radius: CAR.wheelRadius,
  width: CAR.tyreWidth,
  halfTrack: HALF_TRACK,
  style: "alloy"
});
const CAR_4_LAYOUT = layoutOf(["single", "single"]);
const CAR_4_WHEELS = [
  ...axle(1, FRONT_AXLE_X),
  ...axle(2, REAR_AXLE_X)
];
export {
  CAR_4_LAYOUT,
  CAR_4_WHEELS
};
